import store from 'Store'
export const hasTranslate = () => {
    const { locale } = store.getState()
    return locale && locale.translations
}



// WEBPACK FOOTER //
// ./src/services/utils/locale.js